import { render, staticRenderFns } from "./TestVideoStartPageView.vue?vue&type=template&id=6cf75d51&scoped=true&"
import script from "./TestVideoStartPageView.vue?vue&type=script&lang=js&"
export * from "./TestVideoStartPageView.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoStartPageView.vue?vue&type=style&index=0&id=6cf75d51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf75d51",
  null
  
)

export default component.exports